import React from "react";
import { Box, Select, MenuItem, Typography } from "@mui/material";

const MonthSelector = ({
  selectedMonth,
  setSelectedMonth,
  selectedYear,
  setSelectedYear,
}) => {
  const months = [...Array(12).keys()];
  const currentYear = new Date().getFullYear();
  const years = [currentYear, currentYear - 1];

  return (
    <Box display="flex" alignItems="center" gap={2} mb={3}>
      <Typography>Filter by:</Typography>
      <Select
        value={selectedMonth}
        onChange={(e) => setSelectedMonth(e.target.value)}
        size="small"
      >
        {months.map((m) => (
          <MenuItem key={m} value={m}>
            {new Date(0, m).toLocaleString("default", { month: "long" })}
          </MenuItem>
        ))}
      </Select>
      <Select
        value={selectedYear}
        onChange={(e) => setSelectedYear(e.target.value)}
        size="small"
      >
        {years.map((y) => (
          <MenuItem key={y} value={y}>
            {y}
          </MenuItem>
        ))}
      </Select>
    </Box>
  );
};

export default MonthSelector;
